module.exports = __webpack_public_path__ + "media/images/frontend/covid19_sintomas_alt-a2c0aa707a5be3c90566b39dab459d0a.svg";